import React from 'react';
import DataTable from '../../DataTable/DataTable';
import Tabs from '../../Tabs/Tabs';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import numeral from "numeral";
import clsx from "clsx";

export default class OrderCardBuilderFolios extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      dataTableRenderCount: 0,
      transactions_active_tab: this.props.transactions_active_tab ? this.props.transactions_active_tab : 'current_charges',
      folios_active_tab: 'open',
      date_format: this.props.date_format ? this.props.date_format : null,
    }
    this.onChangeActiveFolioTab = this.onChangeActiveFolioTab.bind(this);
    this.onChangeActiveTransactionTab = this.onChangeActiveTransactionTab.bind(this);
  }

  componentDidMount() {
    var self = this;

    $(window).on("refresh_data_table", function () {
      self.setState({dataTableRenderCount: self.state.dataTableRenderCount + 1 });
    });
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == "folios",
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="folios">
        {this.renderFolioDataTables()}
        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }

  renderFolioDataTables() {
    return (
      <>
      <div className="panel panel-default">
        <div className="panel-body container">
          <h3 className="panel-heading-text">{I18n.t("folios")}</h3>
          <div className="table-wrap-panel" >
            <br className="embedded-table-tabs-br" />
            <DataTable endpoint={this.props.order_open_folios_path + '?r=' + this.state.dataTableRenderCount} date_format={this.props.date_format} time_format={this.props.time_format} tab_data_table={true} inModal={true} currency_unit={I18n.t('number.currency.format.unit')} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} />
          </div>
        </div>
      </div>

      <div className="panel panel-default">
        <div className="panel-body container">
          <h3 className="panel-heading-text">{I18n.t("transactions")}</h3>
          <div className="table-wrap-panel" >
            <Tabs tabs={this.transactionTabs()} />
            <br className="embedded-table-tabs-br" />
            {this.state.transactions_active_tab === 'payments' ? <DataTable endpoint={this.props.order_payment_path} date_format={this.props.date_format} time_format={this.props.time_format} tab_data_table={true} inModal={true} currency_unit={I18n.t("number.currency.format.unit")} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} /> : null}
            {this.state.transactions_active_tab === 'current_charges' ? <DataTable endpoint={this.props.order_charges_path} date_format={this.props.date_format} time_format={this.props.time_format} tab_data_table={true} inModal={true} currency_unit={I18n.t('number.currency.format.unit')} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} /> : null}
            {this.state.transactions_active_tab === 'reversed_charges' ? <DataTable endpoint={this.props.order_reversal_charges_path} date_format={this.props.date_format} time_format={this.props.time_format} tab_data_table={true} inModal={true} currency_unit={I18n.t('number.currency.format.unit')} delimiter={I18n.t('number.currency.format.delimiter')} separator={I18n.t('number.currency.format.separator')} /> : null}
          </div>
        </div>
      </div>
      </>
    )
  }

  folioTabs() {
    return (
      [
        {
          tabName: I18n.t('open'),
          targetName: 'open',
          classes: this.state.folios_active_tab === 'open' ? 'active' : null,
          changeHandler: this.onChangeActiveFolioTab,
        },
        {
          tabName: I18n.t('settled'),
          targetName: 'settled',
          classes: this.state.folios_active_tab === 'settled' ? 'active' : null,
          changeHandler: this.onChangeActiveFolioTab,
        }
      ]
    );
  };

  transactionTabs() {
    const transactionTabs = [
      {
        tabName: I18n.t('current_charges'),
        targetName: 'current_charges',
        classes: this.state.transactions_active_tab === 'current_charges' ? 'active' : null,
        changeHandler: this.onChangeActiveTransactionTab,
      },
      {
        tabName: I18n.t('voided_charges'),
        targetName: 'reversed_charges',
        classes: this.state.transactions_active_tab === 'reversed_charges' ? 'active' : null,
        changeHandler: this.onChangeActiveTransactionTab,
      },
      {
        tabName: I18n.t('payments'),
        targetName: 'payments',
        classes: this.state.transactions_active_tab === 'payments' ? 'active' : null,
        changeHandler: this.onChangeActiveTransactionTab,
      }
    ];

    return (transactionTabs)
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  onChangeActiveFolioTab(tab) {
    if (tab) {
      this.setState({
        folios_active_tab: tab,
      });
    };
  };

  onChangeActiveTransactionTab(tab) {
    if (tab) {
      this.setState({
        transactions_active_tab: tab,
      })
    }
  }
};
